import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=5a623da2"
import script from "../services/Users.js?vue&type=script&lang=js&external"
export * from "../services/Users.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports